import { useMemo } from "react";
import { useWindow } from "./useWindow";

export const useWidth = (width = 600) => {
  const { width: viewportWidth } = useWindow();
  let isMobile = useMemo(() => viewportWidth <= width, [viewportWidth]);
  return { isMobile, width: viewportWidth, mobileView: isMobile }; // Change the breakpoint as needed
};
